import React from 'react';
import { dummyClick } from '../utilities';

const flags = {
  en: '/images/flags/gb.gif',
  de: '/images/flags/de.gif'
};

const LangIcon = ({ path, onClick, lang }) => (
  <a className="white text-decoration-none" href={path} onClick={onClick}>
    <img className="mr1" src={flags[lang]} alt={lang} />
    <span className="white">{lang.toUpperCase()}</span>
  </a>
);

LangIcon.defaultProps = {
  path: EMPTY_HREF,
  onClick: dummyClick,
  lang: 'en'
};

export default LangIcon;
